export function toggleInArray(array, item) {
  return array.includes(item) ? array.filter(i => i != item) : array.concat(item)
}
